<template>
    <v-container fluid grid-list-md>
        <v-layout column wrap>
            <v-flex>
                <h1 class="display-3">Gestión de No conformidad {{ ($route.params.id)? $route.params.id : ''}}</h1>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <v-card>
                    <v-card-text>
                        <v-layout row wrap>
                            <v-flex>
                                <v-text-field label="Resumen" v-model="d.resumen" counter clearable maxlength="255"></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex>
                                <v-select
                                        label="Origen"
                                        hint="Origen de la no conformidad"
                                        :items="origenes"
                                        v-model="d.origen_id"
                                        item-value="id"
                                        item-text="desig"
                                ></v-select>
                            </v-flex>
                            <v-flex>
                                <v-menu
                                        :close-on-content-click="false"
                                        v-model="menuFecha"
                                        :nudge-right="40"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        min-width="290px"
                                >
                                    <v-text-field
                                            slot="activator"
                                            v-model="d.fecha"
                                            label="Fecha"
                                            prepend-icon="event"
                                            readonly
                                    ></v-text-field>
                                    <v-date-picker locale="es-ar" v-model="d.fecha" @input="menuFecha = false"></v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex>
                                <v-autocomplete
                                        prepend-icon="person"
                                        clearable
                                        label="Gestor"
                                        item-value="id"
                                        item-text="name"
                                        v-model="d.gestor_id"
                                        :items="users"
                                >
                                </v-autocomplete>
                            </v-flex>
                            <v-flex>
                                <v-autocomplete
                                        prepend-icon="person"
                                        clearable
                                        label="Usuarios asignados"
                                        item-value="id"
                                        item-text="name"
                                        v-model="d.usuarios"
                                        :items="users"
                                        multiple
                                >
                                </v-autocomplete>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap v-if="d.origen_id === 1">
                            <v-flex>
                                <empresa-select v-model="d.empresa_id"></empresa-select>
                            </v-flex>
                            <v-flex>
                                <micro-cliente-select v-model="d.cliente_id" :empresa="d.empresa_id" :preset="d.cliente_id"></micro-cliente-select>
                            </v-flex>
                            <v-flex>
                                <micro-proveedor-select v-model="d.proveedor_id" :empresa="d.empresa_id" :preset="d.proveedor_id"></micro-proveedor-select>
                            </v-flex>
                            <v-flex>
                                <micro-item-select v-model="d.producto_id" :empresa="d.empresa_id" :preset="d.producto_id"></micro-item-select>
                            </v-flex>
                        </v-layout>
                        <!-- <v-layout>
                            <v-flex xs12 sm4 md3>
                                <v-text-field label="Presupuesto" v-model="e.presupuesto"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm4 md3>
                                <v-text-field label="Pedido de venta" v-model="e.pv"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm4 md3>
                                <v-text-field label="Producto" v-model="e.producto"></v-text-field>
                            </v-flex>                            
                        </v-layout> -->                        
                    </v-card-text>
                </v-card>
                <br>
                <v-card>
                    <v-card-text>
                        <v-card-title class="headline">Etapas cumplidas</v-card-title>
                        <v-layout>
                            <template v-for="etapa in etapas">
                                <v-flex>
                                    <v-card dark :color="etapa.color">
                                        <v-card-title class="text-xs-center">
                                            {{ (etapa)? etapa.desig : '' }}
                                        </v-card-title>
                                        <v-divider></v-divider>
                                        <v-card-text v-if="etapa.fecha">
                                            {{etapa.fecha | fecha }}
                                        </v-card-text>
                                        <v-card-text v-if="etapa.activa">
                                            Etapa activa
                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                            </template>
                        </v-layout>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-btn dark flat color="red" v-if="d.etapa_id !== 8" @click.stop="cierreDialog = true" :loading="loadingCerrar">Cerrar NC</v-btn>
                        <v-btn dark flat icon color="blue">
                            <v-icon>print</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn dark color="pink" @click="avisar" :loading="loadingAviso">Enviar aviso</v-btn>
                        <v-btn dark color="orange" @click="avanzar" v-if="d.etapa_id !== 8" :loading="loadingAvanzar">Avanzar etapa</v-btn>
                        <v-btn dark color="green" @click.stop="etapaDialog = true" v-if="d.etapa_id !== 8">Adicionar observaciones</v-btn>
                    </v-card-actions>
                </v-card>
                <br>
                <v-data-table :headers="headers" :items="d.obs" class="elevation-1" hide-actions>
                    <template slot="items" slot-scope="props">
                        <td class="text-xs-center">{{ (props.item.etapa)? props.item.etapa.desig : '' }}</td>
                        <td class="text-xs-center">{{ props.item.created_at }}</td>
                        <td class="text-xs-center">{{ props.item.fecha }}</td>
                        <td class="text-xs-center">
                            <v-chip>
                                <v-avatar>
                                    <img :src="(props.item.usuario.avatar)? props.item.usuario.avatar : 'img/user-image.png'">
                                </v-avatar>
                                {{ props.item.usuario.name }}
                            </v-chip>
                        </td>
                        <td class="text-xs-center">
                            {{ (props.item.archivos.length > 0)?props.item.archivos.length : '' }}
                            <v-icon v-if="props.item.archivos.length > 0">insert_drive_file</v-icon>
                        </td>
                        <td class="text-xs-center">
                            <v-btn icon flat @click="props.expanded = !props.expanded" color="blue">
                                <v-scale-transition mode="out-in">
                                    <v-icon
                                            :key="`icon-${props.expanded}`"
                                            v-text="props.expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
                                    ></v-icon>
                                </v-scale-transition>
                            </v-btn>
                        </td>
                    </template>
                    <template slot="expand" slot-scope="props">
                        <v-card>
                            <v-card-text>
                                <div class="title">Observaciones</div>
                                <br>
                                <v-layout align-center justify-center>
                                    <v-flex>
                                        <v-textarea v-if="obsEdit === props.item.id" v-model="props.item.obs"></v-textarea>
                                        <span v-else>{{ props.item.obs }}</span>
                                    </v-flex>
                                    <v-flex>
                                        <v-btn color="green" v-if="obsEdit === props.item.id" @click="update(props.item)">Guardar</v-btn>
                                        <v-btn color="blue" v-else @click="obsEdit = props.item.id">Editar</v-btn>
                                    </v-flex>
                                </v-layout>
                                <v-divider></v-divider>
                                <br>
                                <div v-if="props.item.encargados_list"><b>Encargado: </b>
                                    <v-chip v-for="(e,index) in props.item.encargados_list" :key="index">{{ e }}</v-chip>
                                </div>
                                <br>
                                <span v-if="props.item.cant"><b>Cantidad a reponer: </b>{{ props.item.cant }}</span>
                                <div v-if="props.item.archivos.length > 0">
                                    <br>
                                    <v-divider></v-divider>
                                    <br>
                                    <div class="title">Archivos</div>
                                    <v-list>
                                        <template v-for="a in props.item.archivos">
                                            <v-list-tile>
                                                <v-list-tile-avatar>
                                                    <v-icon>insert_drive_file</v-icon>
                                                </v-list-tile-avatar>
                                                <v-list-tile-content>
                                                    <v-list-tile-title v-html="a.nom_orig"></v-list-tile-title>
                                                </v-list-tile-content>
                                                <v-list-tile-action>
                                                    <v-slide-x-reverse-transition group>
                                                        <v-progress-circular key="1" v-if="a.progreso > 0 && a.progreso < 100" :value="a.progreso"></v-progress-circular>
                                                        <v-btn key="2" flat icon @click="download(a)" v-if="a.progreso === 0 || a.progreso === 100 || !a.progreso">
                                                            <v-icon>cloud_download</v-icon>
                                                        </v-btn>
                                                    </v-slide-x-reverse-transition>
                                                </v-list-tile-action>
                                            </v-list-tile>
                                        </template>
                                    </v-list>
                                </div>
                            </v-card-text>
                        </v-card>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
        <!--///////////////////////////// ETAPAS DIALOG /////////////////////////////-->
        <v-dialog v-model="etapaDialog" scrollable max-width="600px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>Agregar observaciones a {{ (etapaActiva)? etapaActiva.desig : '' }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="etapaDialog = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-container fluid grid-list-md>
                        <v-layout row wrap>
                            <v-flex xs12 sm3>
                                <v-menu
                                        :close-on-content-click="false"
                                        v-model="menuFechaEtapa"
                                        :nudge-right="40"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        min-width="290px"
                                >
                                    <v-text-field
                                            slot="activator"
                                            v-model="e.fecha"
                                            label="Fecha del evento"
                                            prepend-icon="event"
                                            readonly
                                    ></v-text-field>
                                    <v-date-picker locale="es-ar" v-model="e.fecha" @input="menuFechaEtapa = false"></v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex>
                                <v-text-field label="Cantidad Reclamada" v-model="e.cant"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm4 lg2 v-if="plazoShow.includes(etapaActiva.id)">
                                <v-text-field label="Plazo" v-model="e.plazo" suffix="días">
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout v-if="encargadoShow.includes(etapaActiva.id)">
                            <v-flex>
                                <v-autocomplete
                                        prepend-icon="person"
                                        clearable
                                        label="Encargados"
                                        item-value="id"
                                        item-text="name"
                                        v-model="e.encargados_id"
                                        :items="users"
                                        multiple
                                >
                                </v-autocomplete>
                            </v-flex>
                        </v-layout>

                        <v-layout>
                            <v-flex xs12>
                                <v-textarea label="Observaciones" v-model="e.obs"></v-textarea>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex>
                                <v-btn @click="fileSel()">Seleccionar archivos</v-btn>
                                <v-container grid-list-md fluid>
                                    <v-layout row wrap align-end justify-center>
                                        <template v-for="(f, index) in files">
                                            <v-flex xs12 sm4>
                                                <v-card tile hover>
                                                    <v-img v-if="f.url" :src="f.url" height="150px"></v-img>
                                                    <v-card-text class="text-xs-center">
                                                        {{ f.file.name }}
                                                    </v-card-text>
                                                    <v-card-actions>
                                                        <v-spacer></v-spacer>
                                                        <v-btn flat icon dark color="red" @click="fileRemove(index)">
                                                            <v-icon>delete</v-icon>
                                                        </v-btn>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-flex>
                                        </template>
                                    </v-layout>
                                </v-container>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>

                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat color="red" dark @click="etapaDialog = false">cancelar</v-btn>
                    <v-btn flat color="orange" dark @click="guardar(false)" :loading="loading">guardar</v-btn>
                    <v-btn flat dark color="green" @click="guardar(true)" v-if="d.etapa_id !== 7" :loading="loading">guardar y avanzar etapa</v-btn>
                    <v-btn flat dark color="green" @click="guardar(true)" v-if="d.etapa_id === 7" :loading="loading">guardar y cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--///////////////////////////// DIALOGO DE CIERRES /////////////////////////////-->
        <v-dialog v-model="cierreDialog" width="500">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>Cierre de solicitud</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="cierreDialog = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-checkbox label="¿No procedente?" v-model="e.no_procedente"></v-checkbox>
                    <v-textarea label="Observaciones" v-model="e.obs"></v-textarea>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="cerrar" flat color="green">Confirmar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <input type="file" style="display: none" ref="file" multiple @change="fileProcess($event.target.files)"/>
    </v-container>
</template>

<script>
    import empresaSelect from '../../../components/EmpresaSelect';
    import microClienteSelect from '../../../components/MicroClienteSelect';
    import microProveedorSelect from '../../../components/MicroProveedorSelect';
    import microItemSelect from '../../../components/MicroItemSelect';
    import mixinIncidencia from '../../../mixins/calidad/incidencia';
    import usersMixin from '../../../mixins/auth/users';
    import {mapActions} from 'vuex';
    import saveAs from 'file-saver';
    import moment from 'moment';

    function getInitialData() {
        return {
            id: '',
            origen_id: '',
            empresa_id: '',
            proveedor_id: '',
            cliente_id: '',
            proceso_id: '',
            producto_id: '',
            auditoria_tipo: '',
            estado_id: 1,
            resumen: '',
            fecha: '',
            sectores: [],
            usuarios: [],
            obs: [],
            producto:'',
            pv:'',
            presupuesto:'',
        }
    }

    function formInitialData() {
        return {
            fecha: '',
            obs: '',
            cant: 0,
            no_procedente: false,
            plazo: 0,
            encargados_id: []
        }
    }


    export default {
        name: "crud",
        components: {microItemSelect, microClienteSelect, microProveedorSelect, empresaSelect},
        mixins: [mixinIncidencia, usersMixin],
        data() {
            return {
                obsEdit: -1,
                etapaActiva: {id: 1, desig: ''},
                loading: false,
                etapas: [],
                headers: [
                    {text: 'Etapa', value: 'etapa_id', align: 'center'},
                    {text: 'Fecha creación', value: 'created_at', align: 'center'},
                    {text: 'Fecha', value: 'fecha', align: 'center'},
                    {text: 'Usuario', value: 'user_id', align: 'center'},
                    {text: 'Archivos', value: '', align: 'center'},
                    {text: 'Oper', value: 'obs', align: 'center'},
                ],
                origenes: [],
                d: getInitialData(),
                e: formInitialData(),
                cliente: {},
                users: [],
                sectores: [],
                menuFecha: false,
                menuFechaEtapa: false,
                etapaDialog: false,
                files: [],
                imageTypes: ['image/gif', 'image/jpeg', 'image/png'],
                loadingAvanzar: false,
                loadingCerrar: false,
                loadingAviso: false,
                cierreDialog: false,
                plazoShow: [5],
                encargadoShow: [3, 4, 5]
            }
        },
        filters: {
            fecha(v) {
                return moment(v).fromNow();
            }
        },
        mounted() {
            this.incidenciaOrigenes(r => {
                this.origenes = r;
            }, err => console.log(err));
            this.incidenciaMostrar();
            this.getUsers();
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            avisar() {
                this.loadingAviso = true;
                this.incidenciaAvisar({id: this.$route.params.id}, r => {
                    this.msjShow(r);
                    this.loadingAviso = false;
                }, err => console.log(err))
            },
            estadosGet() {
                this.incidenciaEtapasEstados({id: this.$route.params.id}, r => {
                    this.etapas = r;
                }, err => console.log(err));
            },
            getUsers() {
                this.usersList(r => {
                    this.users = r;
                }, err => {
                    console.log(err);
                });
            },
            incidenciaMostrar() {
                if (this.$route.params.id) {
                    this.incidenciaShow(this.$route.params.id, r => {
                        this.d = r;
                        this.etapaActiva = r.etapa;
                        this.estadosGet();
                    }, err => console.error(err))
                }
            },
            avanzar() {
                this.loadingAvanzar = true;
                this.incidenciaObsStore({
                    'id': this.d.id,
                    'etapa_id': this.d.etapa_id,
                    'obs': this.e.obs,
                    'cant': this.e.cant,
                    'fecha': this.e.fecha,
                    'avanzar': true,
                    'encargados_id': this.encargados_id,
                }, {}, r => {
                    this.msjShow(r);
                    this.incidenciaMostrar();
                    this.e = formInitialData();
                    this.etapaDialog = false;
                    this.loadingAvanzar = false;
                }, err => {
                    this.msjShow({tipo: 2, txt: 'Error al guardar'});
                    this.loadingAvanzar = false;
                })
            },
            guardar(avanzar) {
                this.loading = true;
                let fd = new FormData();
                fd.append('id', this.d.id);
                fd.append('etapa_id', this.d.etapa_id);
                fd.append('obs', this.e.obs);
                fd.append('cant', this.e.cant);
                fd.append('fecha', this.e.fecha);
                fd.append('avanzar', avanzar);
                fd.append('encargados_id', JSON.stringify(this.e.encargados_id));
                for (let i = 0; i < this.files.length; i++) {
                    fd.append('files[' + i + ']', this.files[i].file);
                }
                this.incidenciaObsStore(fd, {headers: {'Content-Type': 'multipart/form-data'}}, r => {
                    this.msjShow(r);
                    this.incidenciaMostrar();
                    this.e = formInitialData();
                    this.files = [];
                    this.$refs.file.value = '';
                    this.loading = false;
                    this.etapaDialog = false;
                }, err => {
                    this.loading = false;
                    this.msjShow({tipo: 2, txt: 'Error al guardar'});
                })
            },
            cerrar() {
                this.cierreDialog = false;
                this.loadingCerrar = true;
                this.incidenciaCerrar({
                    obs: this.e.obs,
                    id: this.d.id,
                    no_procedente: this.e.no_procedente
                }, r => {
                    this.msjShow(r);
                    this.loadingCerrar = false;
                    this.e = formInitialData();
                    this.incidenciaMostrar();
                }, err => {
                    this.msjShow({tipo: 2, txt: 'Error al cerrar incidencia'});
                    this.loadingCerrar = false;
                })
            },
            fileSel() {
                this.$refs.file.click();
            },
            fileProcess(fileList) {
                for (let i = 0; i < fileList.length; i++) {
                    let file = {
                        file: fileList[i],
                        url: (this.imageTypes.includes(fileList[i].type)) ? URL.createObjectURL(fileList[i]) : ''
                    };
                    this.files.push(file)
                }
            },
            fileRemove(index) {
                this.files.splice(index, 1)
            },
            download(a) {
                a.progreso = 0;
                this.$http({
                    method: 'post',
                    url: 'calidad/incidencia/download',
                    headers: {'Content-Type': 'application/json'},
                    responseType: "blob",
                    data: a,
                    onDownloadProgress: (progressEvent) => {
                        const totalLength = progressEvent.lengthComputable ? progressEvent.total : progressEvent.target.getResponseHeader('content-length') || progressEvent.target.getResponseHeader('x-decompressed-content-length');
                        if (totalLength !== null) {
                            a.progreso = Math.round((progressEvent.loaded * 100) / totalLength);
                        }
                    }
                })
                    .then((response) => {
                        a.progreso = 100;
                        saveAs(response.data, a.nom_orig);
                    })
                    .catch((error) => {
                        alert(error);
                    });
            },
            update(data) {
                this.incidenciaObsUpdate({obs: data.obs, id: data.id}, r => {
                    this.msjShow(r);
                    this.obsEdit = -1;
                }, err => {
                    this.msjShow({tipo: 2, txt: 'Error al guardar'});
                })
            }
        }

    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/calidad/no_conformidad/gestion.vue